module.exports = __webpack_public_path__ + "img/zz4.f6c03c3e.png";